import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as warnings from './web3Warning.constants';
import {
  hasAccountConnected,
  hasCorrectAccount,
  hasCorrectNetwork,
} from './web3Warning.selectors';
import { useWeb3React } from 'web3/hooks';

export const useCurrentWarning = ({ user, canClaim }) => {
  const { account, active, chainId, library, metamask } = useWeb3React();
  const [warning, setWarning] = useState();
  const ethAddress = user?.ethAddress[0];
  const screenSize = useSelector((state) => state.navigation.screenSize);

  useEffect(() => {
    const updateWarnings = () => {
      if (screenSize !== 0) return warnings.mobile;
      if (!metamask) return warnings.metamask;
      if (!active || !account) return warnings.connectMetamask;
      if (!hasCorrectNetwork(chainId)) return warnings.network;
      if (!hasAccountConnected(user)) return warnings.connection;
      if (!hasCorrectAccount(user, account)) return warnings.account(ethAddress);
      return null;
    };
    user && setWarning(updateWarnings());
  }, [
    metamask,
    account,
    library,
    active,
    ethAddress,
    chainId,
    user,
    canClaim,
    screenSize,
  ]);
  return warning;
};
